import 'whatwg-fetch'
import {
  API_URL
} from '../constants/configValues'

const account = {
  fetchAccounts(token, systemID) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/accounts/list`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateAccount(token, systemID, account) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/accounts/update`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify(account)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateAccountPermission(token, systemID, permission) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/accounts/set-permission`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify(permission)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPermissions(token, systemID, accountID) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/permissions/${accountID}`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteAccount(token, systemID, account) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/accounts/delete/${account.ID}`, {
        method: 'DELETE',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default account



// WEBPACK FOOTER //
// ./src/api/account.js